var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankAlbiladFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2743 0.000244141H0.0957031V6.03757C1.84204 5.03967 3.88774 4.46587 6.05819 4.46587C8.37832 4.46587 10.5488 5.11451 12.3699 6.2621V2.04595C12.3699 0.923307 11.4219 0.000244141 10.2743 0.000244141Z",
    fill: "#F6B333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.31185 5.7135C2.7651 5.7135 1.34308 6.11266 0.0957031 6.83614V9.9546C0.0957031 11.0772 1.04371 12.0003 2.1913 12.0003H12.3699C11.5217 8.40785 8.22863 5.7135 4.31185 5.7135Z",
    fill: "#CF202E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankAlbiladFavicon);
export default __webpack_public_path__ + "static/media/bank_albilad_favicon.50eac15a017a1c119b339b20426365be.svg";
export { ForwardRef as ReactComponent };